<template>
    <v-row class="mak-kontrol-paneli ml w-full">
        <v-col class="mak-kontrol-paneli-content">
            <v-row>
                <v-card
                    v-for="[key, title, icon, color] in makinaSayilari"
                    :key="title"
                >
                    <v-card-title>Kiradaki</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            :color="color"
                            text-color="white"
                        >
                            <v-icon left>
                                {{ icon }}
                            </v-icon>
                            {{ title }}
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingMakinaSayisi"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingMakinaSayisi">
                            #
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!makina[key]">0</span>
                            <animate-number
                                v-else
                                :ref="key"
                                from="0"
                                :to="makina[key].makina_sayisi"
                                mode="manual"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-row>

            <v-row>
                <v-card>
                    <v-card-title>Bugün</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="light-green"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-try
                            </v-icon>
                            Toplam Tahsilat
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingBugun"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingBugun">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!bugunTahsilat">0</span>
                            <animate-number
                                v-else
                                ref="bugun"
                                from="0"
                                :to="bugunTahsilat.toplam_tahsilat"
                                mode="manual"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card>
                    <v-card-title>Dün</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="light-green"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-try
                            </v-icon>
                            Toplam Tahsilat
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingDun"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingDun">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!dunTahsilat">0</span>
                            <animate-number
                                v-else
                                ref="dun"
                                from="0"
                                :to="dunTahsilat.toplam_tahsilat"
                                mode="manual"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-row>

            <v-row>
                <v-card>
                    <v-card-title>Gecen Ay</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="light-green"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-usd-circle
                            </v-icon>
                            Toplam Tahsilat
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingGecenay"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingGecenay">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!gecenayTahsilat">0</span>
                            <animate-number
                                v-else
                                ref="gecenAy"
                                from="0"
                                :to="gecenayTahsilat.toplam_tahsilat"
                                mode="manual"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card>
                    <v-card-title>Bu Ay</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="light-green"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-usd-circle
                            </v-icon>
                            Toplam Tahsilat
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingBuay"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingBuay">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!buayTahsilat">0</span>
                            <animate-number
                                v-else
                                ref="buAy"
                                from="0"
                                :to="buayTahsilat.toplam_tahsilat"
                                mode="manual"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-row>

            <v-row>
                <v-card>
                    <v-card-title>Geçen Ay</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="teal"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-usd-circle
                            </v-icon>
                            Toplam Prim
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingGecenay"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingGecenay">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!gecenayPrim">0</span>
                            <animate-number
                                v-else
                                from="0"
                                :to="gecenayPrim"
                                duration="2000"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card>
                    <v-card-title>Bu Ay</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-chip
                            color="teal"
                            text-color="white"
                        >
                            <v-icon left>
                                mdi-currency-usd-circle
                            </v-icon>
                            Toplam Prim
                        </v-chip>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-text>
                        <v-progress-circular
                            v-if="loadingBuay"
                            :size="30"
                            :width="3"
                            color="purple"
                            indeterminate/>
                        <div v-show="!loadingBuay">
                            ₺
                            <span class="mak-toplam-tahsilat">
                            <span v-if="!buayPrim">0</span>
                            <animate-number
                                v-else
                                from="0"
                                :to="buayPrim"
                                duration="2000"/>
                        </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: 'mak-kontrol-paneli',

        data() {
            return {
                loadingBugun: false,
                loadingDun: false,
                loadingBuay: false,
                loadingGecenay: false,
                loadingMakinaSayisi: false,
                bugunTahsilat: null,
                dunTahsilat: null,
                buayTahsilat: null,
                gecenayTahsilat: null,
                makina: {
                    aktif: null,
                    pasif: null,
                    makinalar_calismiyor: null,
                },
                makinaSayilari: [
                    ['aktif', 'Aktif Makina', 'mdi-checkbox-marked-circle', 'green'],
                    ['pasif', 'Pasif Makina', 'mdi-alert-circle', 'orange'],
                    ['makinalar_calismiyor', 'Çalışmıyor', 'mdi-pause-circle', 'red'],
                ],
            };
        },

        computed: {
            buayPrim() {
                if (!this.buayTahsilat) {
                    return 0;
                }
                return this.buayTahsilat.toplam_tahsilat * 0.08
            },
            gecenayPrim() {
                if (!this.gecenayTahsilat) {
                    return 0;
                }
                return this.gecenayTahsilat.toplam_tahsilat * 0.08
            },
        },

        methods: {
            fetchBugun() {
                this.loadingBugun = true;
                this.$requests.Tahsilat
                    .getBugunTahsilat()
                    .then((data) => {
                        if (data) {
                            this.bugunTahsilat = data;
                            this.startAnimate('bugun');
                        }
                    })
                    .catch((e) => {
                        console.error('error on fetching bugunTahsilat', e);
                    })
                    .then(() => {
                        this.loadingBugun = false;
                    })
            },
            fetchDun() {
                this.loadingDun = true;
                this.$requests.Tahsilat
                    .getDunTahsilat()
                    .then((data) => {
                        if (data) {
                            this.dunTahsilat = data;
                            this.startAnimate('dun');
                        }
                    })
                    .catch((e) => {
                        console.error('error on fetching dunTahsilat', e);
                    })
                    .then(() => {
                        this.loadingDun = false;
                    })
            },
            fetchMakinaSayisi() {
                this.loadingMakinaSayisi = true;
                this.$requests.Tahsilat
                    .getMakinaSayisi()
                    .then((data) => {
                        if (data) {
                            this.makina = data;

                            //
                            Object.keys(this.makina).forEach((ref) => {
                                this.startAnimate(ref, true);
                            });
                        }
                    })
                    .catch((e) => {
                        console.error('error on fetching dunTahsilat', e);
                    })
                    .then(() => {
                        this.loadingMakinaSayisi = false;
                    })
            },
            fetchBuay() {
                this.loadingBuay = true;
                this.$requests.Tahsilat
                    .getBuayTahsilat()
                    .then((data) => {
                        if (data) {
                            this.buayTahsilat = data;
                            this.startAnimate('buAy');
                        }
                    })
                    .catch((e) => {
                        console.error('error on fetching dunTahsilat', e);
                    })
                    .then(() => {
                        this.loadingBuay = false;
                    })
            },
            fetchGecenay() {
                this.loadingGecenay = true;
                this.$requests.Tahsilat
                    .getGecenayTahsilat()
                    .then((data) => {
                        if (data) {
                            this.gecenayTahsilat = data;
                            this.startAnimate('gecenAy');
                        }
                    })
                    .catch((e) => {
                        console.error('error on fetching dunTahsilat', e);
                    })
                    .then(() => {
                        this.loadingGecenay = false;
                    })
            },
            startAnimate(ref, isArray = false) {
                this.$nextTick(() => {
                    const el = isArray
                        ? this.$refs[ref][0]
                        : this.$refs[ref];
                    if (el) {
                        el.start();
                    }
                });
            },
        },

        mounted() {
            this.fetchBugun();
            this.fetchDun();
            this.fetchBuay();
            this.fetchGecenay();
            this.fetchMakinaSayisi();
        }
    }
</script>

<style lang="scss">
    .mak-kontrol-paneli {

        .mak-kontrol-paneli-content {
            margin-left: 1rem;

            .v-card {
                margin: 1em 0.5em;
            }
        }

        .mak-toplam-tahsilat {
            font-size: 1.5em;
        }

    }
</style>
